// #region SmsRegistration
export enum SenderIdStatus {
  PENDING_COMREG = 'pending-comreg',
  PENDING_TWILIO = 'pending-twilio',
  REJECTED_COMREG = 'rejected-comreg',
  READY = 'ready',
}

export type SenderId = {
  id: string;
  status: SenderIdStatus;
  isActive: boolean;
};

export type GetOrgSenderIdsQueryParams = {
  brandId?: string;
};

export type PutTwilioSmsRegistrationRequestBody = {
  orgId: string;
  brandId: string;
  registeredSenderId: string;
  countryCode: string;
  status: SenderIdStatus;
  isActive: boolean;
};
// #endregion
